var chunkToChildrenMap = {
	"5385": [
		3873,
		8144,
		3912,
		1869,
		9372,
		2702
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};